<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-1">There Was a Crooked Man</p>
<p class="Book-Subtitle" xml:lang="en-GB">A Cat DeLuca Mystery</p>
<p class="Book-Author" xml:lang="en-GB">K. J. Larsen</p>
<p class="Body-Center"><a href="http://kjlarsenauthor.com" target="_blank"><span class="Hyperlink" xml:lang="en-US">kjlarsenauthor.com</span></a></p>
<p class="Book-Publisher para-style-override-1" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="Body-Center"><span><img alt="PPPlogo.jpg" class="frame-1" src="image/PPPlogo_fmt.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// There_Was_a_Crooked_Man.vue?1233b5e6